module.exports = __webpack_public_path__ + "static/media/calig-dark.f5458f72.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/calig-dark.png
// module id = 30
// module chunks = 0